import { DateUtils } from "../Utils/DateUtils";

export class OWDate extends Date {
    constructor();
    constructor(value: number | string | Date);
    constructor(year?: any, month?: number, date?: number) {
        if (month || month === 0)
            super(year, month, date);
        else {
            if (year instanceof Date)
                super(year.getTime());
            else if (typeof year === "string") {
                const parsedVal = DateUtils.fromXsdDateTime(year);
                super(parsedVal ? parsedVal.getTime() : Number.NaN); // pokud se nepovedlo sparsovat bude vracen Invalid Date
            } else
                super(year);

            super.setHours(0, 0, 0, 0);
        }
    }

    public override toString(): string {
        return super.toDateString();
    }

    public override toTimeString(): string {
        return "";
    }

    public override toLocaleTimeString(): string {
        return "";
    }

    public override toLocaleString(locale?: string | string[], options?: Intl.DateTimeFormatOptions): string {
        return super.toLocaleDateString(locale as any, options);
    }

    public override toLocaleDateString(locale?: string | string[], options?: Intl.DateTimeFormatOptions): string {
        return super.toLocaleDateString(locale as any, options);
    }

    public override toJSON(): string {
        return DateUtils.toXsdDateTime(this).substr(0, 10);
    }
}
